<template>
    <div>
        <div class="banner news-bn">
            <img src="@/assets/images/banner8.png" alt="">
            <h2 class="title">NEWS｜今天來點什嘛</h2>
        </div>
        <div class="wrap">
            <section id="tabs-block" class="section">
                <ul class="text-center">
                    <li>
                        <a href="javascript:void(0);" class="tabs-item tabsFilter" @click="select_type('building')">
                            <div class="name">
                                大樓<br>公告
                            </div>
                            <p>Notice</p>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" class="tabs-item tabsFilter" @click="select_type('all')">  
                            <div class="name">
                                所有<br>訊息
                            </div>
                            <p>All Message</p>
                        </a>
                    </li>
                </ul>
            </section>
            <section class="section filter-block">
                <div class="row">
                     <div v-for="news_list in news_lists" :key="news_list.id" class="col col2" data-category="Activity">
                        <div class="card">
                            <div class="left">
                                <div class="img">
                                    <img :src="JSON.parse(news_list.images_url)[0]" :alt="news_list.title">
                                </div>
                                <p>{{ news_list.title }}</p>
                            </div>
                            <div class="right">
                                <div class="name">
                                    {{the_type[news_list.news_type]}}
                                    <span>
                                        {{the_type_en[news_list.news_type]}}
                                    </span>
                                </div>
                                <ul>
                                    <li>
                                        <i class="icon date">
                                            <img src="@/assets/images/icon_date.svg" alt="">
                                        </i>
                                        {{ news_list.enable_time }}
                                    </li>
                                    <li class="text_length">
                                        {{ news_list.content }}
                                    </li>
                                </ul>
                            </div>
                            <router-link :to="{name: 'newsPage', params: {id: news_list.id} }" class="link">
                                深入了解
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'news',
    data () {
        return {
            select_active: false,
            select_active_2: false,
            select_active_3: true,
            news_lists: [],
            the_type: {
                message: '一般訊息',
                building: '大樓公告'
            },
            the_type_en: {
                building: 'Notice',
                message: 'News'
            }
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'NewsList');
        formData.append('news_type', 'all');
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
                console.log('NewsList: Server Error');
            } else {
                const get_lists = response.data.news_list;
                this.news_lists = get_lists;
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    methods: {
        get_list (type) {
            const getData = new FormData();
            getData.append('CMD', 'NewsList');
            getData.append('news_type', type);
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
            .then(response => {
                // console.log(response);
                if (response.data.result == false) {
                    console.log('NewsList: Server Error');
                } else {
                    const get_lists = response.data.news_list;
                    this.news_lists = get_lists;
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        select_type(type) {
            this.get_list (type);
        }
    }
};
</script>

<style>
.text_length{
    height: 250px;
    overflow: hidden;
    /* text-overflow: ellipsis; */
    /* white-space: nowrap!important; */
}
</style>
